var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-switch",
        _vm._g(
          _vm._b(
            {
              attrs: { "active-value": 1, "inactive-value": 0 },
              on: { change: _vm.switchChange },
              model: {
                value: _vm.getValue,
                callback: function ($$v) {
                  _vm.getValue = $$v
                },
                expression: "getValue",
              },
            },
            "yxt-switch",
            _vm.$attrs.attrs,
            false
          ),
          _vm.$attrs.on
        )
      ),
      _c(
        "span",
        { staticClass: "tlive-create__switch--text tlive-create__tip" },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t(
                  "pc_biz_willShowCompanyInThisLiveRoom" /* 开启后，将在直播间展示企业 */
                )
              ) +
              "\n    logo\n    "
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.goToSet,
                  expression: "goToSet",
                },
              ],
              staticClass: "set-logo",
              on: { click: _vm.goSetLogo },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_setLogo" /* 去设置logo */)) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }